import React, { useState } from 'react';
import './LabelIndicator.scss';
import Tooltip from '../../base/tooltip';
import { LABEL_BUTTON_CLASS } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';
import DeleteLabelModal from 'chameleon/legacy/src/components/TeacherOrganize/components/Labels/DeleteLabelModal';
import { DeleteModalConfirmation } from 'chameleon/legacy/src/components/TeacherOrganize/components/Labels/DeleteLabelModal/utils';
import { truncate } from 'lodash';
import ButtonWithIcon from '../../buttons/button-with-icon';

const LabelIndicator = ({
  name,
  removeLabelHandler,
  labelId,
  assessmentTitle,
}) => {
  const [showDeleteLabelConfirm, setShowDeleteLabelConfirm] = useState(false);

  const confirmationMessage = DeleteModalConfirmation({
    name,
    assessmentTitle,
  });
  const deleteModalTitle = `Remove ${name} from ${assessmentTitle}`;

  const handleButtonClick = () => {
    setShowDeleteLabelConfirm(true);
  };
  const onDeleteLabelHandler = () => {
    removeLabelHandler();
    setShowDeleteLabelConfirm(false);
  };

  return (
    <div className="labelIndicator">
      <Tooltip description={name}>
        <div className="label">
          {truncate(name, { length: 17, omission: '...' })}
        </div>
      </Tooltip>
      <ButtonWithIcon
        iconWidth={14}
        isIcon
        isNaked
        size="tiny"
        tabIndex={0}
        icon="close"
        onClick={handleButtonClick}
        aria-label="Close"
        accessibility={{
          'aria-label': `Cloze ${name}`,
        }}
        className="closeButton"
        dataTestId={`my-assignments-${LABEL_BUTTON_CLASS.delete}-${labelId}`}
      />
      {showDeleteLabelConfirm && (
        <DeleteLabelModal
          label={{}}
          onDelete={onDeleteLabelHandler}
          onCancel={() => setShowDeleteLabelConfirm(false)}
          confirmationMessage={confirmationMessage.myAssignments}
          title={deleteModalTitle}
        />
      )}
    </div>
  );
};

export default LabelIndicator;
